export default {
  title: 'Identifiants du personnel',
  form: {
    username: {
      label: "Nom d'utilisateur",
      placeholder: "Nom d'utilisateur",
    },
    password: {
      label: 'Mot de passe',
      placeholder: 'Mot de passe',
    },
    button: {
      title: 'Enregistrer',
    },
    success: 'Informations enregistrées avec succès.',
  },
};
